import { ChevronRight, ChevronDown, Pencil, Trash2, Plus } from "lucide-react";

interface TreeRowProps {
  name: string;
  isExpanded?: boolean;
  isSelected: boolean;
  hasChildren?: boolean;
  icon?: string;
  onToggle?: () => void;
  onClick: () => void;
  onDelete: () => void;
  onAddChild?: () => void;
  addChildLabel?: string;
}

export const TreeRow = ({
  name,
  isExpanded,
  isSelected,
  hasChildren,
  icon,
  onToggle,
  onClick,
  onDelete,
  onAddChild,
  addChildLabel,
}: TreeRowProps) => (
  <div
    className={`flex items-center justify-between px-3 py-2 rounded-md cursor-pointer transition-colors ${
      isSelected ? "bg-blue-100 border border-blue-300" : "bg-white border border-gray-200 hover:bg-gray-50"
    }`}
    onClick={onClick}
  >
    <div className="flex items-center gap-2 flex-1 min-w-0">
      {hasChildren && onToggle && (
        <button onClick={(e) => { e.stopPropagation(); onToggle(); }} className="text-gray-400 hover:text-gray-600">
          {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </button>
      )}
      {icon && <span className="text-xs">{icon}</span>}
      <span className="text-sm font-medium truncate">{name}</span>
    </div>
    <div className="flex items-center gap-1">
      {onAddChild && (
        <button
          onClick={(e) => { e.stopPropagation(); onAddChild(); }}
          className="p-1 text-green-600 hover:bg-green-50 rounded"
          title={addChildLabel || "Add child"}
        >
          <Plus className="w-3.5 h-3.5" />
        </button>
      )}
      <button
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        className="p-1 text-blue-600 hover:bg-blue-50 rounded"
        title="Edit"
      >
        <Pencil className="w-3.5 h-3.5" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onDelete(); }}
        className="p-1 text-red-600 hover:bg-red-50 rounded"
        title="Delete"
      >
        <Trash2 className="w-3.5 h-3.5" />
      </button>
    </div>
  </div>
);

interface LeafRowProps {
  name: string;
  subtitle?: string;
  isSelected: boolean;
  onClick: () => void;
  onDelete: () => void;
}

export const LeafRow = ({
  name,
  subtitle,
  isSelected,
  onClick,
  onDelete,
}: LeafRowProps) => (
  <div
    className={`flex items-center justify-between px-3 py-1.5 rounded cursor-pointer transition-colors ${
      isSelected ? "bg-blue-50 border border-blue-200" : "bg-gray-50 border border-transparent hover:bg-gray-100"
    }`}
    onClick={onClick}
  >
    <div className="flex items-center gap-2 min-w-0">
      <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
      <span className="text-sm truncate">{name}</span>
      {subtitle && <span className="text-xs text-gray-400 truncate">{subtitle}</span>}
    </div>
    <div className="flex items-center gap-1">
      <button
        onClick={(e) => { e.stopPropagation(); onClick(); }}
        className="p-1 text-blue-600 hover:bg-blue-50 rounded"
        title="Edit"
      >
        <Pencil className="w-3 h-3" />
      </button>
      <button
        onClick={(e) => { e.stopPropagation(); onDelete(); }}
        className="p-1 text-red-600 hover:bg-red-50 rounded"
        title="Delete"
      >
        <Trash2 className="w-3 h-3" />
      </button>
    </div>
  </div>
);
